export default "__VITE_ASSET__adbbffcd__"